import { defineStore } from 'pinia';
import type { PortfolioFilter } from '@/data/types';

export const usePortfolioStore = defineStore('portfolio', {
  state: () => ({
    currentFilter: 'tudo' as PortfolioFilter,
  }),
  actions: {
    setFilter(filter: PortfolioFilter) {
      this.currentFilter = filter;
    },
  },
});
